import React, { useState } from "react";
import { Box, CircularProgress, Menu, MenuItem, Popover } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useGetLostMainReasonSubReasonQuery} from "@/services/swarmsApi";
import { createErrorMessage } from "@/utils/index";

export function LostMenu({ children, onSelect, loading, disabled = false, style }) {

  const { data: lostMainReasonSubReason, isLoading, error, isError } = useGetLostMainReasonSubReasonQuery();

  const [anchorEl, setAnchorEl] = useState(null);
  const [reasonExpanded, setReasonExpanded] = useState(null); 

  function handleClick(event) {
    if(disabled) return;
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClose() {
    setAnchorEl(null);
    setReasonExpanded(null);
  }

  const onLostClick = async (mainReasonId, subReasonId) => {
    await onSelect( mainReasonId, subReasonId );
  };

  const toggleExpandReason = (id) => {
    setReasonExpanded((prev) => (prev === id ? null : id));
  };

  if(isLoading) return <CircularProgress />;

  return (
    <>
      <Box
        className="lost-menu-wrapper"
        aria-owns={anchorEl ? "simple-menu" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={style}
      >
        { children }
      </Box>

      {!isError && (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          // MenuListProps={{ onMouseLeave: handleClose }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom", 
            horizontal: "right",  
          }}
        >        
          {lostMainReasonSubReason && lostMainReasonSubReason.map((swarmBuyRequestLostMainReason, lostMainReasonSubReasonIndex) => (
            <div key={`reason-${swarmBuyRequestLostMainReason.id}`}>
              <div 
                style={{ color: 'var(--orange)', fontWeight: 600, padding: '8px 16px', display: "flex", alignItems: "center", justifyContent: "space-between", width:'500px', cursor: 'pointer' }} 
                onClick={() => toggleExpandReason(swarmBuyRequestLostMainReason.id)}
              >
                {swarmBuyRequestLostMainReason.name}
                <ExpandMoreIcon style={{ transform: reasonExpanded === swarmBuyRequestLostMainReason.id ? "rotate(180deg)" : "rotate(0deg)" }}/>
              </div>
              <div 
                style={{ overflow: 'hidden', maxHeight: reasonExpanded === swarmBuyRequestLostMainReason.id ? '500px' : '0px', opacity: reasonExpanded === swarmBuyRequestLostMainReason.id ? 1 : 0, padding: reasonExpanded === swarmBuyRequestLostMainReason.id ? '8px 0' : '0px', transition: 'opacity 0.6s ease' }}
              >
                {swarmBuyRequestLostMainReason.swarmBuyRequestLostSubReason?.map((swarmBuyRequestLostSubReason) => (
                  <MenuItem 
                    key={`subReason-${swarmBuyRequestLostSubReason.id}`} 
                    disabled={Boolean(loading)} value={swarmBuyRequestLostSubReason.id} 
                    onClick={() => onLostClick(swarmBuyRequestLostMainReason.id, swarmBuyRequestLostSubReason.id)} 
                    style={{ transition: 'padding 0.6s ease-in-out, opacity 0.6s ease-in-out', paddingLeft: 16 }}
                  >
                    {swarmBuyRequestLostSubReason.name}
                  </MenuItem>
                ))}
              </div>
              {lostMainReasonSubReasonIndex < lostMainReasonSubReason.length - 1 && <hr style={{ color:'lightgray' }}/>}
            </div>
          ))}
        </Menu>
      )}

      {isError && error && (
        <Popover
          id="error-popover"
          open={Boolean(anchorEl) && isError}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Box sx={{ padding: 2, maxWidth: 400, textAlign:'center' }}>
            {createErrorMessage(error)}
          </Box>
        </Popover>
      )}
    </>
  );
}
